

















































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';

import { designStore } from '@/store/store';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import { UnitSystem } from '@/interfaces/units';
import {
  IAcOverlayDesignImperial,
  IAcOverlayDesignMetric,
  IAcOverlayLayerImperial,
  IAcOverlayLayerMetric,
} from '@/modules/design/interfaces/acOverlay';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import { Route } from 'vue-router';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';
import { createAcOverlayValidations } from '@/modules/design/lib/validations/acOverlay';

// Necessary for dynamic esalMethodValidations
Component.registerHooks(['validations']);

@Component({
  components: {
    ValidatedInputPageWrapper,
    PxDropdown,
    QuickHelp,
    PxNumberInput,
    InputPageWrapper,
  },

})
export default class AcOverlayLayers extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario(): IAcOverlayDesignImperial | IAcOverlayDesignMetric {
    return designStore.currentAcOverlay;
  }

  get scenarioImperial(): IAcOverlayDesignImperial {
    return designStore.currentAcOverlayImperial;
  }

  validations() {
    return createAcOverlayValidations(this.scenarioImperial);

    // const validations: any = {
    //   scenarioImperial: {
    //     existingLayerCoeff: {
    //       required,
    //       minValue: minValue(0)
    //     },
    //     overlayLayerMinimumThickness_in: {
    //       required,
    //       minValue: minValue(0)
    //     },
    //     subgradeModulus_psi: {
    //       required,
    //       minValue: minValue(0)
    //     }
    //   },
    //   layerMapForValidation: {} // Dynamic validation placeholder
    // };
    //
    // // Create a validation for each available layer
    // Object.values(this.layerMapForValidation).forEach((layer) => {
    //   if (layer.id) {
    //     validations.layerMapForValidation[layer.id] = {
    //       thickness_in: {
    //         required,
    //         minValue: minValue(0)
    //       }
    //     }
    //   }
    // });

    // return validations
  }


  save() {
    this.sync();
    designStore.saveCurrentAcOverlayScenario();
  }

  sync() {
    designStore.setCurrentAcOverlayScenario(this.scenario);
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next();
  }

  get layerMapForValidation() {
    const layers: { [index: number]: IAcOverlayLayerImperial } = {};
    this.scenarioImperial.existingLayers.forEach((layer) => {
      if (layer.id) {
        layers[layer.id] = layer;
      }
    });
    return layers;
  }

  layerFields = ['layer_number', 'type', 'thickness', 'actions'];
  // layers: { type: string, thickness: number }[] = [
  //   {type: 'Asphalt - Dense Graded', thickness: 5},
  //   {type: 'Cement treated base', thickness: 4},
  // ];

  layerTypes = [
    'Asphalt - Dense Graded',
    'Asphalt - Open Graded',
    'Aggregate Base',
    'Cement treated base',
    'Bituminous treated base',
    'Asphalt stabilized base',
    'Subbase',
    'Other',
  ];

  get layerTypeOptions() {
    return this.layerTypes.map((t) => ({ value: t, text: t }));
  }

  addLayer() {
    if (!this.scenario.existingLayers) {
      this.scenario.existingLayers = [];
    }

    designStore.currentAcOverlayImperial.existingLayers.push({
      id: null,
      type: 'Asphalt - Dense Graded',
      thickness_in: 4,
      layerCoefficient: null,
      drainageCoefficient: 1,
      sn: 0.35,
    });


    this.save();
  }

  deleteLayer(layer: IAcOverlayLayerImperial | IAcOverlayLayerMetric) {
    // @ts-ignore - no compatible call signatures
    this.scenario.existingLayers = this.scenario.existingLayers.filter((x) => x !== layer);
    this.save();
  }

  get numLayers() {
    // Required for validating whether the user has created any layers.
    return this.scenarioImperial.existingLayers.length;
  }

  unitSystemImperial = UnitSystem.Imperial;

  get unitSystemIsImperial() {
    return this.scenario.displayUnits === UnitSystem.Imperial;
  }

  /*
  Modulus calculation tooling
   */

  rValue = 0;


  modulusCalculationMethod: 'R-Value' | 'CBR' | null = null;

  modulusCalculationMethodOptions = [
    { value: 'R-Value', text: 'R-Value' },
    { value: 'CBR', text: 'CBR' },
    { value: null, text: 'Manual' },
  ];

  get modulusCalculationHelptext(): string | null {
    switch (this.scenario.modulusCalculationMethod) {
      case 'R-Value':
        return '<strong>Calculation:</strong> MR = 1,000 + (555)(R-value)';
      case 'CBR':
        return '<strong>Calculation:</strong> MR = 2555 x CBR^0.64';
    }
    return 'Please determine the subgrade modulus.';
  }

  calculateModulus() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      if (this.modulusCalculationMethod === 'R-Value') {
        this.scenario.subgradeModulus_psi = 1000 + 555 * this.rValue;
      }
      this.sync();
    }
  }

  calcModulusFromRValue() {
    // @ts-ignore
    this.scenarioImperial.subgradeModulus_psi = Number((1000 + 555 * this.scenarioImperial.subgradeRValue).toFixed(2));
    return true; // Return true to play nice with getting called from "&& doStuff()" in v-in
  }

  calcModulusFromCbr() {
    // @ts-ignore
    this.scenarioImperial.subgradeModulus_psi = Number((2555 * Math.pow(this.scenarioImperial.subgradeCbr, 0.64)).toFixed(2));
    return true; // Return true to play nice with getting called from "&& doStuff()" in v-in
  }

  subgradeSoilType: string | null = null;

  subgradeAashtoModulusBounds = {
    'A-1-a': [38500, 42000],
    'A-1-b': [35500, 40000],
    'A-2-4': [28000, 37500],
    'A-2-5': [24000, 33000],
    'A-2-6': [21500, 31000],
    'A-2-7': [21500, 28000],
    'A-3': [24500, 35500],
    'A-4': [21500, 29000],
    'A-5': [17000, 25500],
    'A-6': [13500, 24000],
    'A-7-5': [8000, 17500],
    'A-7-6': [5000, 13500],
  };

  get subgradeSoilTypeOptions() {
    const soilTypes = Object.keys(this.subgradeAashtoModulusBounds).map((k): { value: string | null, text: string } => ({
      value: k,
      text: k,
    }));
    soilTypes.unshift({ value: null, text: '---------' }); // Prepend default option
    return soilTypes;
  }


  get pressureUnit() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return 'psi';
    }
    return 'MPa';
  }

  get thicknessUnit() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return 'in';
    }
    return 'cm';
  }
}


